import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
// @mui
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Stack,
  Typography,
  alpha,
} from '@mui/material';
// hooks
import useCountdown from '../hooks/useCountdown';
// _mock
import { _socials } from '../_mock/arrays';
// components
import { CustomTextField } from '../components/custom-input';
import Iconify from '../components/iconify';
// assets
import { ComingSoonIllustration } from '../assets/illustrations';

// ----------------------------------------------------------------------

export default function ComingSoonPage() {
  const { t } = useTranslation();

  const { days, hours, minutes, seconds } = useCountdown(
    new Date('07/07/2024 21:30'),
  );

  return (
    <>
      <Helmet>
        <title>{t('systemPages.comingSoonTitle')}</title>
      </Helmet>

      <Typography variant="h3" paragraph>
        {t('systemPages.comingSoonHeading')}
      </Typography>

      <Typography sx={{ color: 'text.secondary' }}>
        {t('systemPages.comingSoonBody')}
      </Typography>

      <ComingSoonIllustration sx={{ my: 10, height: 240 }} />

      <Stack
        direction="row"
        justifyContent="center"
        divider={<Box sx={{ mx: { xs: 1, sm: 2.5 } }}>:</Box>}
        sx={{ typography: 'h2' }}
      >
        <TimeBlock
          label={String(t('systemPages.comingSoonDays'))}
          value={days}
        />

        <TimeBlock
          label={String(t('systemPages.comingSoonHours'))}
          value={hours}
        />

        <TimeBlock
          label={String(t('systemPages.comingSoonMinutes'))}
          value={minutes}
        />

        <TimeBlock
          label={String(t('systemPages.comingSoonSeconds'))}
          value={seconds}
        />
      </Stack>

      <CustomTextField
        fullWidth
        placeholder={String(t('systemPages.comingSoonEmailPlaceholder'))}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Button variant="contained" size="large">
                {t('systemPages.comingSoonNotifyMe')}
              </Button>
            </InputAdornment>
          ),
          sx: { pr: 0.5 },
        }}
        sx={{ my: 5 }}
      />

      <Stack
        spacing={1}
        alignItems="center"
        justifyContent="center"
        direction="row"
      >
        {_socials.map((social) => (
          <IconButton
            key={social.name}
            sx={{
              color: social.color,
              '&:hover': {
                bgcolor: alpha(social.color, 0.08),
              },
            }}
          >
            <Iconify icon={social.icon} />
          </IconButton>
        ))}
      </Stack>
    </>
  );
}

// ----------------------------------------------------------------------

type TimeBlockProps = {
  label: string;
  value: string;
};

function TimeBlock({ label, value }: TimeBlockProps) {
  return (
    <div>
      <Box> {value} </Box>
      <Box sx={{ color: 'text.secondary', typography: 'body1' }}>{label}</Box>
    </div>
  );
}
